// store/modules/user.js
const USER_INFO_KEY = 'bearing_mall_user_info'
const ACCESS_TOKEN_KEY = 'bearing_mall_access_token'
const REFRESH_TOKEN_KEY = 'bearing_mall_refresh_token'

// 同步获取本地存储数据
const getLocalStorageData = () => {
  try {
    const userInfo = localStorage.getItem(USER_INFO_KEY)
    const accessToken = localStorage.getItem(ACCESS_TOKEN_KEY)
    const refreshToken = localStorage.getItem(REFRESH_TOKEN_KEY)

    return {
      userInfo: userInfo ? JSON.parse(userInfo) : null,
      accessToken: accessToken || '',
      refreshToken: refreshToken || ''
    }
  } catch (error) {
    console.error('从本地存储读取用户数据失败:', error)
    return {
      userInfo: null,
      accessToken: '',
      refreshToken: ''
    }
  }
}

// 同步设置本地存储数据
const setLocalStorageData = (userInfo, accessToken, refreshToken) => {
  try {
    if (userInfo) {
      localStorage.setItem(USER_INFO_KEY, JSON.stringify(userInfo))
    } else {
      localStorage.removeItem(USER_INFO_KEY)
    }
    
    if (accessToken) {
      localStorage.setItem(ACCESS_TOKEN_KEY, accessToken)
    } else {
      localStorage.removeItem(ACCESS_TOKEN_KEY)
    }
    
    if (refreshToken) {
      localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken)
    } else {
      localStorage.removeItem(REFRESH_TOKEN_KEY)
    }
  } catch (error) {
    console.error('保存用户数据到本地存储失败:', error)
  }
}

// 同步清除本地存储数据
const clearLocalStorageData = () => {
  try {
    localStorage.removeItem(USER_INFO_KEY)
    localStorage.removeItem(ACCESS_TOKEN_KEY)
    localStorage.removeItem(REFRESH_TOKEN_KEY)
  } catch (error) {
    console.error('从本地存储清除用户数据失败:', error)
  }
}

// 初始化状态
const localStorageData = getLocalStorageData()

const state = {
  userInfo: localStorageData.userInfo,
  accessToken: localStorageData.accessToken,
  refreshToken: localStorageData.refreshToken,
  isLogin: !!(localStorageData.userInfo && localStorageData.accessToken)
}

const mutations = {
  SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo
    state.isLogin = true
    setLocalStorageData(userInfo, state.accessToken, state.refreshToken)
  },
  
  SET_TOKEN(state, { accessToken, refreshToken }) {
    state.accessToken = accessToken
    state.refreshToken = refreshToken || state.refreshToken
    state.isLogin = !!(state.userInfo && accessToken)
    setLocalStorageData(state.userInfo, accessToken, state.refreshToken)
  },
  
  SET_TOKENS(state, { accessToken, refreshToken }) {
    state.accessToken = accessToken
    state.refreshToken = refreshToken
    state.isLogin = !!(state.userInfo && accessToken)
    setLocalStorageData(state.userInfo, accessToken, refreshToken)
  },
  
  CLEAR_USER_INFO(state) {
    state.userInfo = null
    state.accessToken = ''
    state.refreshToken = ''
    state.isLogin = false
    clearLocalStorageData()
  },
  
  UPDATE_ACCESS_TOKEN(state, accessToken) {
    state.accessToken = accessToken
    if (accessToken) {
      state.isLogin = true
    }
    setLocalStorageData(state.userInfo, accessToken, state.refreshToken)
  }
}

const actions = {
  setUserInfo({ commit }, userInfo) {
    commit('SET_USER_INFO', userInfo)
  },
  
  setToken({ commit }, tokenData) {
    commit('SET_TOKEN', tokenData)
  },
  
  setTokens({ commit }, tokens) {
    commit('SET_TOKENS', tokens)
  },
  
  updateAccessToken({ commit }, accessToken) {
    commit('UPDATE_ACCESS_TOKEN', accessToken)
  },
  
  clearUserInfo({ commit }) {
    commit('CLEAR_USER_INFO')
  },
  
  logout({ commit }) {
    commit('CLEAR_USER_INFO')
  }
}

const getters = {
  userInfo: state => state.userInfo,
  isLogin: state => state.isLogin,
  accessToken: state => state.accessToken,
  refreshToken: state => state.refreshToken
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}